import type { BlockHeadingProps } from '@epilot/concorde-elements'
import { BlockHeading as ConcordeBlockHeading } from '@epilot/concorde-elements'
import type { PropsWithChildren } from 'react'

export function BlockHeading({
  title,
  subtitle,
  children,
  isGroup,
  required
}: PropsWithChildren<BlockHeadingProps>) {
  if (!title && !subtitle) {
    return <>{children}</>
  }

  return (
    <ConcordeBlockHeading
      isGroup={isGroup}
      required={required}
      subtitle={subtitle}
      title={title}
    >
      {children}
    </ConcordeBlockHeading>
  )
}
